import React, { useState, useEffect } from 'react';
// Simplificando para não depender de bibliotecas externas para formatação
import { useAtividade } from '../../contexts/AtividadeContext';
import { useNavigate } from 'react-router-dom';

const ListaAtividades: React.FC = () => {
  const { 
    atividades, 
    atividadesNaoLidas, 
    marcarComoLida, 
    marcarTodasComoLidas, 
    carregando, 
    erro, 
    carregarMaisAtividades,
    atualizacoesTempoReal,
    toggleAtualizacoesTempoReal
  } = useAtividade();
  const navigate = useNavigate();
  const [carregandoMais, setCarregandoMais] = useState(false);
  const [atividadesLocais, setAtividadesLocais] = useState<any[]>([]);
  
  // Efeito para sincronizar atividades do contexto com o estado local
  // Isso garante que o componente re-renderize quando as atividades mudarem
  useEffect(() => {
    console.log('ListaAtividades: Atualizando atividades locais', atividades.length);
    setAtividadesLocais([...atividades]);
  }, [atividades]);
  
  // Função para navegar para a página da tarefa
  const handleVerTarefa = (tarefaId: string) => {
    navigate(`/tarefas/${tarefaId}`);
  };

  const formatarDataHora = (data_hora: string) => {
    const data = new Date(data_hora);
    return data.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatarTempoRelativo = (data_hora: string) => {
    const data = new Date(data_hora);
    const agora = new Date();
    const diff = agora.getTime() - data.getTime();
    
    // Converter para minutos, horas, dias
    const minutos = Math.floor(diff / 60000);
    const horas = Math.floor(minutos / 60);
    const dias = Math.floor(horas / 24);
    
    if (dias > 0) {
      return dias === 1 ? 'há 1 dia' : `há ${dias} dias`;
    } else if (horas > 0) {
      return horas === 1 ? 'há 1 hora' : `há ${horas} horas`;
    } else if (minutos > 0) {
      return minutos === 1 ? 'há 1 minuto' : `há ${minutos} minutos`;
    } else {
      return 'agora mesmo';
    }
  };

  const getIconeAtividade = (tipo: string) => {
    switch (tipo) {
      case 'criacao':
        return <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>;
      case 'comentario':
        return <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>;
      case 'mudanca_status':
        return <svg className="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>;
      case 'mencao':
        return <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" /></svg>;
      case 'prazo_proximo':
        return <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
      case 'aprovacao_solicitada':
        return <svg className="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
      default:
        return <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center">
          <h2 className="text-lg font-semibold mr-3 text-bravo-dark dark:text-gray-100">Atividades Recentes</h2>
          <button 
            onClick={toggleAtualizacoesTempoReal}
            className={`flex items-center px-2 py-1 rounded text-xs ${atualizacoesTempoReal ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}
            title={atualizacoesTempoReal ? 'Desativar atualizações em tempo real' : 'Ativar atualizações em tempo real'}
          >
            {atualizacoesTempoReal ? (
              <>
                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span>Tempo real</span>
              </>
            ) : (
              <>
                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Pausado</span>
              </>
            )}
          </button>
        </div>
        <div className="flex items-center">
          {atividadesNaoLidas > 0 && (
            <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full mr-2">
              {atividadesNaoLidas}
            </span>
          )}
          <button
            onClick={marcarTodasComoLidas}
            className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
          >
            Marcar todas como lidas
          </button>
        </div>
      </div>
      
      {carregando && atividadesLocais.length === 0 ? (
        <div className="flex justify-center py-8">
          <svg className="animate-spin h-8 w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      ) : (
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {atividadesLocais.length === 0 ? (
            <p className="text-gray-500 dark:text-gray-400 text-center py-4">Nenhuma atividade recente</p>
          ) : (
            atividadesLocais.map((atividade) => (
              <div
                key={atividade.id}
                className={`flex p-3 rounded-lg ${atividade.lida ? 'bg-gray-50 dark:bg-gray-700/50' : 'bg-blue-50 dark:bg-blue-950'}`}
              >
              <div className="mr-3 flex-shrink-0">
                {getIconeAtividade(atividade.tipo)}
              </div>
              <div className="flex-grow">
                <div className="flex justify-between">
                  <h3 className="text-sm font-medium text-bravo-dark dark:text-gray-100">{atividade.titulo}</h3>
                  {!atividade.lida && (
                    <button
                      onClick={() => marcarComoLida(atividade.id)}
                      className="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                    >
                      Marcar como lida
                    </button>
                  )}
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">{atividade.descricao}</p>
                <div className="flex justify-between items-center mt-2">
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {formatarTempoRelativo(atividade.data_hora)}
                  </p>
                  <button
                    className="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                    onClick={() => handleVerTarefa(atividade.tarefa_id || '')}
                  >
                    Ver tarefa
                  </button>
                </div>
                {atividade.tipo === 'mudanca_status' && (
                  <div className="mt-2 flex items-center text-xs">
                    <span className="text-gray-500 dark:text-gray-400">Status alterado de </span>
                    <span className="mx-1 px-1.5 py-0.5 bg-gray-200 dark:bg-gray-600 dark:text-gray-100 rounded">{atividade.status_anterior}</span>
                    <span className="text-gray-500 dark:text-gray-400 mx-1">para</span>
                    <span className="px-1.5 py-0.5 bg-green-100 dark:bg-green-900 dark:text-green-200 rounded">{atividade.status_novo}</span>
                  </div>
                )}
              </div>
            </div>
          )))
          }
          
          {/* Botão para carregar mais atividades */}
          {!carregando && atividades.length > 0 && (
            <div className="mt-4 text-center">
              <button
                onClick={async () => {
                  setCarregandoMais(true);
                  await carregarMaisAtividades();
                  setCarregandoMais(false);
                }}
                className="px-4 py-2 text-sm bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
                disabled={carregandoMais}
              >
                {carregandoMais ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-700 dark:text-gray-200 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Carregando...
                  </>
                ) : (
                  'Carregar mais'
                )}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ListaAtividades;
